import React, { useEffect, useMemo } from "react";
import { ConfigProvider, theme as antdTheme, App as AntApp } from "antd";
import { useSelector } from "react-redux";
import frFR from 'antd/locale/fr_FR';
import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import trTR from 'antd/locale/tr_TR';
import nlNL from 'antd/locale/nl_NL';
const { defaultAlgorithm, darkAlgorithm } = antdTheme;

// --- LIGHT THEME (Google-vari) ---
const LIGHT = {
  // Global tokens
  token: {
    // Temel palet
    colorPrimary: "#1a73e8",
    colorInfo: "#1a73e8",
    colorSuccess: "#1e8e3e",
    colorWarning: "#fbbc04",
    colorError: "#d93025",

    // Metin / zemin
    colorTextBase: "#202124",
    colorTextSecondary: "#5f6368",
    colorBorder: "#dadce0",
    colorSplit: "#e6e9ec",

    colorBgBase: "#ffffff",
    colorBgContainer: "#ffffff",
    colorBgLayout: "#f8f9fa",

    // Boyutlar
    controlHeightSM: 28,
    controlHeight: 36,
    controlHeightLG: 40,

    // Radius
    borderRadius: 12,
    borderRadius: 10,
    borderRadiusLG: 14,

    // Gölge
    boxShadow:
      "0 1px 2px rgba(60,64,67,0.10), 0 1px 3px rgba(60,64,67,0.08)",
    boxShadowSecondary:
      "0 1px 3px rgba(60,64,67,0.12)",

    // Tipografi
    fontWeightStrong: 600,
  },

  // Component-specific dokunuşlar
  components: {
    Card: {
      borderRadiusLG: 12,
      paddingSM: 16,
      padding: 20,
      colorBorder: "#e0e3e7",
      boxShadow:
        "0 1px 2px rgba(60,64,67,0.10), 0 1px 3px rgba(60,64,67,0.08)",
    },
    Button: {
      borderRadius: 12,
      // primary tonları
      colorPrimary: "#1a73e8",
      colorPrimaryHover: "#1669c1",
      colorPrimaryActive: "#1558aa",
      primaryShadow: "none",
      // default buton (type=default)
      defaultShadow: "none",
      colorText: "#1a73e8",
      colorBgContainer: "#ffffff",
      colorBorder: "#dadce0",
    },
    Input: {
      borderRadius: 12,
      colorBorder: "#dadce0",
      activeShadow: "none",
      hoverBorderColor: "#1a73e8",
      activeBorderColor: "#1a73e8",
      paddingBlock: 8,
      paddingInline: 12,
    },
    Select: {
      borderRadius: 12,
      colorBorder: "#dadce0",
      optionSelectedBg: "#e8f0fe",
      optionSelectedColor: "#1a73e8",
      optionActiveBg: "#f1f3f4",
    },
    Layout: {
      colorBgBody: "#f8f9fa",
    },
    Menu: {
      itemBorderRadius: 10,
      itemSelectedBg: "#e8f0fe",
      itemSelectedColor: "#1a73e8",
      itemHoverBg: "#f1f3f4",
    },
    Tabs: {
      inkBarColor: "#1a73e8",
      itemSelectedColor: "#1a73e8",
    },
    Tag: { borderRadius: 12 },
    Radio: { buttonBg: "#f1f3f4", colorPrimary: "#1a73e8" },
    Breadcrumb: { lastItemColor: "#5f6368" },
  },
};

// --- DARK THEME (aynı tasarımın koyu karşılıkları) ---
const DARK = {
  token: {
    // Temel palet
    colorPrimary: "#8ab4f8",
    colorInfo: "#244f94ff",
    colorSuccess: "#34a853",
    colorWarning: "#fbbc04",
    colorError: "#ea4335",

    // Metin / Link / Zemin
    colorTextBase: "#e8eaed",
    colorText: "#e8eaed",              // antd v5 komponentleri burada
    colorTextSecondary: "#bdc1c6",
    colorLink: "#e8eaed",              // Button type="link" + <a>
    colorLinkHover: "#ffffff",
    colorLinkActive: "#ffffff",

    colorBorder: "#3c4043",
    colorSplit: "#2a2e31",

    colorBgBase: "#121314",
    colorBgContainer: "#1a1c1e",
    colorBgLayout: "#121314",

    // Boyutlar
    controlHeightSM: 28,
    controlHeight: 36,
    controlHeightLG: 40,

    // Radius
    borderRadius: 12,
    borderRadius: 10,
    borderRadiusLG: 14,

    // Gölge
    boxShadow: "0 1px 2px rgba(0,0,0,0.50), 0 1px 3px rgba(0,0,0,0.35)",
    boxShadowSecondary: "0 1px 3px rgba(0,0,0,0.55)",

    fontWeightStrong: 600,
  },
  components: {
    Card: {
      borderRadiusLG: 12,
      paddingSM: 16,
      padding: 20,
      colorBorder: "#2a2e31",
      boxShadow: "0 1px 2px rgba(0,0,0,0.40)",
      colorBgContainer: "#1a1c1e",
    },

    // ---- Button: link/ghost/default metinleri beyaz ----
    Button: {
      borderRadius: 12,
      // primary
      colorPrimary: "#244f94ff",
      colorPrimaryHover: "#7aa4eb",
      colorPrimaryActive: "#6b93d8",
      primaryShadow: "none",
      // default/text/link
      defaultShadow: "none",
      colorText: "#e8eaed",         // default & text varyantlarının yazısı
      colorLink: "#e8eaed",         // link varyantı yazısı
      colorLinkHover: "#ffffff",
      colorLinkActive: "#ffffff",
      colorBgContainer: "#1a1c1e",
      colorBorder: "#3c4043",
    },

    // ---- Descriptions: içerik & label kontrast ----


    Input: {
      borderRadius: 12,
      colorBgContainer: "#1a1c1e",
      colorText: "#e8eaed",
      colorBorder: "#3c4043",
      hoverBorderColor: "#244f94ff",
      activeBorderColor: "#244f94ff",
      activeShadow: "none",
      paddingBlock: 8,
      paddingInline: 12,
    },
    Select: {
      borderRadius: 12,
      colorBgContainer: "#1a1c1e",
      colorText: "#e8eaed",
      colorBorder: "#3c4043",
      optionSelectedBg: "rgba(138,180,248,0.16)",
      optionSelectedColor: "#8ab4f8",
      optionActiveBg: "#212327",
    },
    Layout: { colorBgBody: "#121314", colorText: "#e8eaed" },
    Menu: {
      itemBorderRadius: 10,
      itemSelectedBg: "rgba(138,180,248,0.16)",
      itemSelectedColor: "#8ab4f8",
      itemHoverBg: "#1f2125",
      colorItemBg: "transparent",
      colorItemText: "#e8eaed",
    },
    Tabs: { inkBarColor: "#8ab4f8", itemSelectedColor: "#8ab4f8" },
    Tag: { borderRadius: 12, colorBorder: "#3c4043" },
    Radio: { buttonBg: "#1f2125", colorPrimary: "#8ab4f8" },
    Breadcrumb: { lastItemColor: "#bdc1c6" },
  },
};

export default function ThemeProvider({ children }) {
  const mode = useSelector((s) => s.theme.mode);
  const storeLang = useSelector((s) => s.theme.language);
  const isDark = mode === "dark";

  // Seçili palet
  const palette = isDark ? DARK : LIGHT;

  useEffect(() => {

  }, [isDark]);


  const localeSeletor = useMemo(() => {
    switch (storeLang) {
      case 'FR':
        return frFR;
      case 'DE':
        return deDE;
      case 'EN':
        return enUS;
      case 'TR':
        return trTR;
      case 'NL':
        return nlNL;
      default:
        return nlNL;
    }
  }, [storeLang]);

  return (
    <ConfigProvider
      locale={localeSeletor}
      theme={{
        // Algoritmayı açık/dark veriyoruz; ama kendi tokenlarımız üstte.
        algorithm: isDark ? darkAlgorithm : defaultAlgorithm,
        // İstersen css değişkenleri aç: cssVar: true,
        ...palette,
      }}
    >
      <AntApp>
        {children}
      </AntApp>
    </ConfigProvider>
  );
}
